import { Grid } from '@chipinside/frontend'

export function FormbuilderContainer(props) {
  return <Grid {...props} container spacing={2} />
}
